export const defaultLocation = process.env.MIX_DEFAULT_LOCATION
export const defaultCity = process.env.MIX_DEFAULT_CITY
export const defaultAttendanceChannel = process.env.MIX_DEFAULT_ATTENDANCE_CHANNEL
export const defaultServiceRequestPriority = process.env.MIX_DEFAULT_SERVICE_REQUEST_PRIORITY_ID

export const generateTreatmentProtocol = false